module.exports = __webpack_public_path__ + "static/media/sf-test-8.fd30c49c.mp3";